import { useDeviceType } from '@cian/ui-kit/responsive';
import { useSelector } from 'react-redux';

import { DESKTOP_SIDEBAR_WIDTH } from '../../../../common/constants/desktopSidebar';
import { selectIsDesktopListingVisible } from '../../../../common/selectors/desktopListing';

// Ширина desktop listing, которую карта учитывает при резервировании видимой области и safeArea превью.
// На мобиле/планшете листинг живёт в модалке, поэтому для карты ширина равна 0.
export function useDesktopListingOverlayWidth(): number {
  const deviceType = useDeviceType();
  const isListingVisible = useSelector(selectIsDesktopListingVisible);

  return deviceType === 'desktop' && isListingVisible ? DESKTOP_SIDEBAR_WIDTH : 0;
}
